import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgToday2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M6 22H15.9792C16.9589 22 17.9045 21.6405 18.6367 20.9896L20.6575 19.1934C21.5114 18.4343 22 17.3463 22 16.2037V6C22 3.79086 20.2091 2 18 2H6C3.79086 2 2 3.79086 2 6V18C2 20.2092 3.79086 22 6 22Z",
		stroke: "currentColor",
		strokeWidth: 1.5
	}), /* @__PURE__ */ _jsx("path", {
		d: "M13.1507 7.77271V16.5H11.8296V9.09373H11.7785L9.69043 10.4574V9.196L11.868 7.77271H13.1507Z",
		fill: "currentColor"
	})]
});
export default SvgToday2;
